var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLinkArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 14.625L6.85833 16.0583C6.05292 16.8637 4.74708 16.8637 3.94167 16.0583C3.13625 15.2529 3.13625 13.9471 3.94167 13.1417L7.725 9.35C8.49625 8.57625 9.73878 8.54326 10.55 9.275L10.65 9.35833C10.9791 9.6805 11.507 9.6749 11.8292 9.34583C12.1513 9.01676 12.1457 8.48883 11.8167 8.16667C11.7696 8.10585 11.7196 8.04745 11.6667 7.99167C10.1905 6.70736 7.97134 6.78752 6.59167 8.175L2.75833 11.9667C1.40496 13.4398 1.45319 15.7178 2.86769 17.1323C4.2822 18.5468 6.56023 18.595 8.03333 17.2417L9.475 15.8333C9.77031 15.5112 9.76657 15.0156 9.46643 14.6979C9.16628 14.3803 8.67172 14.3484 8.33333 14.625ZM17.2417 2.75833C15.7824 1.3081 13.426 1.3081 11.9667 2.75833L10.525 4.16667C10.2297 4.48883 10.2334 4.9844 10.5336 5.30207C10.8337 5.61974 11.3283 5.65157 11.6667 5.375L13.1083 3.94167C13.9137 3.13625 15.2196 3.13625 16.025 3.94167C16.8304 4.74708 16.8304 6.05292 16.025 6.85833L12.2417 10.65C11.4704 11.4238 10.2279 11.4567 9.41667 10.725L9.31667 10.6417C8.9876 10.3195 8.45967 10.3251 8.1375 10.6542C7.81533 10.9832 7.82093 11.5112 8.15 11.8333C8.21053 11.8952 8.27452 11.9537 8.34167 12.0083C9.81932 13.2885 12.0352 13.2084 13.4167 11.825L17.2083 8.03333C18.6678 6.58321 18.6827 4.22678 17.2417 2.75833Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkArrow);
export default __webpack_public_path__ + "static/media/CopyLinkArrow.046450db77017546cffb4d9e4a7358d3.svg";
export { ForwardRef as ReactComponent };